import { isDesktopUp, isTabletLandscapeUp } from '../../utils/breakpoints';

const getPrevEllipses = (current, total, noOfPagesToSpread, page) => {
  const prevEllipses = [{ isEllipses: true, page }];
  const shouldShowEllipses = total <= noOfPagesToSpread + 2;
  if (current === 3) return [];
  if (total === 2) return [];
  if (shouldShowEllipses && page === 1) return [];
  if (shouldShowEllipses) return [{ page, isCurrent: current === page }];

  if (
    total > noOfPagesToSpread + 2 &&
    current <= noOfPagesToSpread &&
    current >= total - noOfPagesToSpread
  ) {
    return prevEllipses;
  }
  if (current <= noOfPagesToSpread) return [];
  return prevEllipses;
};

const getNextEllipses = (current, total, noOfPagesToSpread, page) => {
  const nextEllipses = [{ isEllipses: true, page }];
  const shouldShowEllipses = total <= noOfPagesToSpread + 2;
  if (total === 2) return [];
  if (shouldShowEllipses && page === total) return [];
  if (shouldShowEllipses) return [{ page, isCurrent: current === page }];
  if (current > total - noOfPagesToSpread) return [];
  return nextEllipses;
};

const getPageSpread = (current, total, noOfPagesToSpread) => {
  const totalArray = [...Array(total + 1).keys()];
  totalArray.shift();

  let start = 1,
    end = noOfPagesToSpread;

  if (total < noOfPagesToSpread + 2) {
    start = 1;
    end = total - 1;
  } else if (current > total - noOfPagesToSpread) {
    start = total - noOfPagesToSpread;
    end = total - 1;
  } else if (current > noOfPagesToSpread) {
    start = current - 1;
    end = current - 1 + noOfPagesToSpread - 2;
  }

  const spreadPages = totalArray.slice(start, end).map(page => ({
    page,
    isCurrent: current === page
  }));
  return spreadPages;
};

export const getPages = (current, total) => {
  const firstPage = { page: 1, isCurrent: current === 1 };
  const lastPage = { page: total, isCurrent: current === total };
  const noOfPagesToSpread = isDesktopUp() ? 8 : 3;

  const spreadPages = getPageSpread(current, total, noOfPagesToSpread);
  const prevSpreadPage = (spreadPages?.[0]?.page || 0) - 1;
  const nextSpreadPage = (spreadPages[spreadPages.length - 1]?.page || 0) + 1;

  const pages = [
    firstPage,
    ...getPrevEllipses(current, total, noOfPagesToSpread, prevSpreadPage),
    ...spreadPages,
    ...getNextEllipses(current, total, noOfPagesToSpread, nextSpreadPage),
    lastPage
  ];

  return pages;
};
